var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlayBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_2630",
    "data-name": "Raggruppa 2630",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 270.201,
    height: 80.06,
    viewBox: "0 0 270.201 80.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1746",
    "data-name": "Rettangolo 1746",
    width: 270.201,
    height: 80.06,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2627",
    "data-name": "Raggruppa 2627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2626",
    "data-name": "Raggruppa 2626",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3525",
    "data-name": "Tracciato 3525",
    d: "M260.194,80.059H10.007A10.037,10.037,0,0,1,0,70.052V10.007A10.037,10.037,0,0,1,10.007,0H260.194A10.037,10.037,0,0,1,270.2,10.007V70.052a10.037,10.037,0,0,1-10.008,10.007",
    fill: "#100e0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3526",
    "data-name": "Tracciato 3526",
    d: "M260.194,1.6a8.415,8.415,0,0,1,8.406,8.406V70.053a8.415,8.415,0,0,1-8.406,8.406H10.007A8.415,8.415,0,0,1,1.6,70.053V10.008A8.415,8.415,0,0,1,10.007,1.6Zm0-1.6H10.007A10.037,10.037,0,0,0,0,10.008V70.053A10.037,10.037,0,0,0,10.007,80.06H260.194A10.037,10.037,0,0,0,270.2,70.053V10.008A10.037,10.037,0,0,0,260.194,0",
    transform: "translate(0 -0.001)",
    fill: "#a09c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3527",
    "data-name": "Tracciato 3527",
    d: "M250.622,90.989a8.513,8.513,0,1,0,8.544,8.514,8.392,8.392,0,0,0-8.544-8.514m0,13.672a5.172,5.172,0,1,1,4.8-5.158,4.925,4.925,0,0,1-4.8,5.158M231.98,90.989a8.513,8.513,0,1,0,8.546,8.514,8.392,8.392,0,0,0-8.546-8.514m0,13.672a5.172,5.172,0,1,1,4.805-5.158,4.924,4.924,0,0,1-4.805,5.158M209.808,93.6v3.61h8.641a7.538,7.538,0,0,1-1.965,4.545,8.848,8.848,0,0,1-6.675,2.644,9.609,9.609,0,0,1,0-19.216,9.206,9.206,0,0,1,6.513,2.578l2.548-2.546a12.6,12.6,0,0,0-9.061-3.645,13.222,13.222,0,1,0,0,26.442,12.089,12.089,0,0,0,9.221-3.709,11.932,11.932,0,0,0,3.128-8.448,11.665,11.665,0,0,0-.194-2.256Zm90.683,2.8c-.711-1.9-2.87-5.418-7.287-5.418-4.385,0-8.028,3.451-8.028,8.514a8.33,8.33,0,0,0,8.446,8.513,8.471,8.471,0,0,0,7.1-3.773l-2.9-1.936a4.863,4.863,0,0,1-4.193,2.354,4.332,4.332,0,0,1-4.127-2.578l11.383-4.709Zm-11.609,2.838a4.669,4.669,0,0,1,4.45-4.966,3.293,3.293,0,0,1,3.16,1.805Zm-9.255,8.254h3.741V82.477h-3.741ZM273.5,92.892h-.128a5.9,5.9,0,0,0-4.481-1.9,8.521,8.521,0,0,0,0,17.027,5.8,5.8,0,0,0,4.481-1.936h.128v1.225c0,3.258-1.739,5-4.545,5a4.71,4.71,0,0,1-4.289-3.03l-3.256,1.355a8.111,8.111,0,0,0,7.546,5.03c4.385,0,8.094-2.58,8.094-8.867V91.505H273.5Zm-4.287,11.769a5.177,5.177,0,0,1,0-10.318c2.548,0,4.545,2.194,4.545,5.192,0,2.966-2,5.126-4.545,5.126m48.8-22.182h-8.949V107.5H312.8V98.02h5.216c4.139,0,8.208-3,8.208-7.772s-4.069-7.77-8.208-7.77m.1,12.059H312.8V85.959h5.312a4.29,4.29,0,1,1,0,8.578m23.081-3.593c-2.7,0-5.506,1.191-6.665,3.829l3.316,1.385a3.538,3.538,0,0,1,3.413-1.835c1.932,0,3.895,1.159,3.927,3.219V97.8a8.273,8.273,0,0,0-3.895-.965c-3.573,0-7.211,1.963-7.211,5.632,0,3.349,2.93,5.5,6.213,5.5a5.268,5.268,0,0,0,4.765-2.446h.128v1.932h3.6V97.864c0-4.441-3.314-6.919-7.6-6.919m-.45,13.712c-1.225,0-2.93-.612-2.93-2.126,0-1.931,2.124-2.67,3.959-2.67a6.664,6.664,0,0,1,3.413.837,4.527,4.527,0,0,1-4.442,3.959m21.18-13.166-4.281,10.848h-.128l-4.443-10.848h-4.023l6.663,15.161-3.8,8.434H355.8l10.269-23.6ZM328.28,107.5h3.735V82.478H328.28Z",
    transform: "translate(-114.249 -47.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3528",
    "data-name": "Tracciato 3528",
    d: "M69.5,92.948l-21.31,22.617s0,.01,0,.014a5.761,5.761,0,0,0,8.478,3.471l.068-.04,23.986-13.84Z",
    transform: "translate(-28.032 -54.071)",
    fill: "#da1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3529",
    "data-name": "Tracciato 3529",
    d: "M120.019,75.372l-.02-.014-10.355-6L97.977,79.737l11.709,11.7,10.3-5.942a5.76,5.76,0,0,0,.034-10.128",
    transform: "translate(-56.996 -40.347)",
    fill: "#fead00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3530",
    "data-name": "Tracciato 3530",
    d: "M47.914,44.393a5.654,5.654,0,0,0-.2,1.481V85.84a5.544,5.544,0,0,0,.2,1.479L69.956,65.28Z",
    transform: "translate(-27.759 -25.825)",
    fill: "#396bb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3531",
    "data-name": "Tracciato 3531",
    d: "M69.654,59.911,80.682,48.885,56.725,34.994a5.767,5.767,0,0,0-8.536,3.447s0,0,0,.006Z",
    transform: "translate(-28.031 -19.879)",
    fill: "#3b9030"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2629",
    "data-name": "Raggruppa 2629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2628",
    "data-name": "Raggruppa 2628",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3532",
    "data-name": "Tracciato 3532",
    d: "M199.945,33.038h3.987a6.929,6.929,0,0,1,3.37.784,5.427,5.427,0,0,1,2.211,2.2,7.194,7.194,0,0,1,0,6.495,5.426,5.426,0,0,1-2.211,2.2,6.929,6.929,0,0,1-3.37.784h-3.987ZM203.88,43.7a4.46,4.46,0,0,0,3.3-1.175,4.389,4.389,0,0,0,1.175-3.247,4.389,4.389,0,0,0-1.175-3.247,4.46,4.46,0,0,0-3.3-1.175h-2.02V43.7Z",
    transform: "translate(-116.314 -19.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1747",
    "data-name": "Rettangolo 1747",
    width: 1.915,
    height: 12.468,
    transform: "translate(96.463 13.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3533",
    "data-name": "Tracciato 3533",
    d: "M242.384,44.492a4.7,4.7,0,0,1-1.724-2.542l1.811-.732a3.493,3.493,0,0,0,.993,1.707,2.445,2.445,0,0,0,1.724.662,2.585,2.585,0,0,0,1.593-.488,1.58,1.58,0,0,0,.653-1.341,1.666,1.666,0,0,0-.575-1.3,6.082,6.082,0,0,0-1.985-1l-.783-.279a5.836,5.836,0,0,1-2.116-1.262,2.842,2.842,0,0,1-.844-2.15,3.128,3.128,0,0,1,.5-1.707,3.442,3.442,0,0,1,1.393-1.236,4.44,4.44,0,0,1,2.029-.453,3.989,3.989,0,0,1,2.595.793,4.033,4.033,0,0,1,1.323,1.785l-1.724.732a2.1,2.1,0,0,0-.731-1.08,2.219,2.219,0,0,0-1.446-.453,2.308,2.308,0,0,0-1.445.453,1.389,1.389,0,0,0-.592,1.149,1.318,1.318,0,0,0,.531,1.071,5.574,5.574,0,0,0,1.645.81l.8.279a6.308,6.308,0,0,1,2.473,1.446,3.236,3.236,0,0,1,.87,2.368,3.322,3.322,0,0,1-.618,2.046A3.717,3.717,0,0,1,247.146,45a5.123,5.123,0,0,1-1.977.4,4.6,4.6,0,0,1-2.786-.906",
    transform: "translate(-140 -18.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3534",
    "data-name": "Tracciato 3534",
    d: "M267.428,33.038h4.283a4.348,4.348,0,0,1,2.046.488,3.8,3.8,0,0,1,1.48,1.358,3.8,3.8,0,0,1,0,3.935,3.8,3.8,0,0,1-1.48,1.358,4.348,4.348,0,0,1-2.046.488h-2.368v4.841h-1.915Zm4.336,5.816a2.051,2.051,0,0,0,1.541-.6,1.976,1.976,0,0,0,0-2.8,2.051,2.051,0,0,0-1.541-.6h-2.421v4Z",
    transform: "translate(-155.571 -19.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3535",
    "data-name": "Tracciato 3535",
    d: "M294.45,44.527a6.292,6.292,0,0,1-2.324-2.359,6.8,6.8,0,0,1,0-6.565,6.3,6.3,0,0,1,2.324-2.359A6.444,6.444,0,0,1,303.34,35.6a6.8,6.8,0,0,1,0,6.565,6.526,6.526,0,0,1-8.889,2.359m5.581-1.541a4.36,4.36,0,0,0,1.637-1.672,5.212,5.212,0,0,0,0-4.858,4.356,4.356,0,0,0-1.637-1.671,4.662,4.662,0,0,0-4.58,0,4.351,4.351,0,0,0-1.637,1.671,5.209,5.209,0,0,0,0,4.858,4.355,4.355,0,0,0,1.637,1.672,4.665,4.665,0,0,0,4.58,0",
    transform: "translate(-169.447 -18.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3536",
    "data-name": "Tracciato 3536",
    d: "M328.041,33.038H330.3l5.642,9.159h.1l-.1-2.4V33.038h1.9V45.506H335.86l-5.92-9.629h-.1l.1,2.4v7.226h-1.9Z",
    transform: "translate(-190.832 -19.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1748",
    "data-name": "Rettangolo 1748",
    width: 1.915,
    height: 12.468,
    transform: "translate(150.165 13.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3537",
    "data-name": "Tracciato 3537",
    d: "M371.088,33.038h4.667a4.007,4.007,0,0,1,1.846.435,3.456,3.456,0,0,1,1.35,1.193,3,3,0,0,1,.5,1.681,2.824,2.824,0,0,1-.461,1.611,3.01,3.01,0,0,1-1.228,1.053V39.1a3.147,3.147,0,0,1,1.55,1.1,2.935,2.935,0,0,1,.574,1.811,3.191,3.191,0,0,1-.531,1.819,3.614,3.614,0,0,1-1.428,1.236,4.353,4.353,0,0,1-1.959.444h-4.876Zm4.58,5.242a1.864,1.864,0,0,0,1.393-.531,1.7,1.7,0,0,0,.522-1.228,1.657,1.657,0,0,0-.513-1.21,1.8,1.8,0,0,0-1.333-.514H373V38.28Zm.3,5.45a1.966,1.966,0,0,0,1.454-.548,1.841,1.841,0,0,0-.017-2.638,2.055,2.055,0,0,0-1.507-.558H373V43.73Z",
    transform: "translate(-215.874 -19.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1749",
    "data-name": "Rettangolo 1749",
    width: 1.915,
    height: 12.468,
    transform: "translate(166.533 13.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3538",
    "data-name": "Tracciato 3538",
    d: "M410.263,33.038h1.915V43.7h5.363v1.811h-7.278Z",
    transform: "translate(-238.663 -19.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3539",
    "data-name": "Tracciato 3539",
    d: "M432.493,33.038h7.557v1.811h-5.642v3.517h5.084v1.811h-5.084V43.7h5.642v1.811h-7.557Z",
    transform: "translate(-251.595 -19.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3540",
    "data-name": "Tracciato 3540",
    d: "M465.606,44.492a4.7,4.7,0,0,1-1.724-2.542l1.811-.732a3.493,3.493,0,0,0,.993,1.707,2.445,2.445,0,0,0,1.724.662A2.585,2.585,0,0,0,470,43.1a1.58,1.58,0,0,0,.653-1.341,1.666,1.666,0,0,0-.575-1.3,6.082,6.082,0,0,0-1.985-1l-.783-.279a5.836,5.836,0,0,1-2.116-1.262,2.842,2.842,0,0,1-.844-2.15,3.128,3.128,0,0,1,.5-1.707,3.442,3.442,0,0,1,1.393-1.236,4.44,4.44,0,0,1,2.029-.453,3.989,3.989,0,0,1,2.595.793,4.033,4.033,0,0,1,1.323,1.785l-1.724.732a2.1,2.1,0,0,0-.731-1.08,2.219,2.219,0,0,0-1.446-.453,2.309,2.309,0,0,0-1.445.453,1.389,1.389,0,0,0-.592,1.149,1.318,1.318,0,0,0,.531,1.071,5.574,5.574,0,0,0,1.645.81l.8.279a6.308,6.308,0,0,1,2.473,1.446,3.235,3.235,0,0,1,.87,2.368,3.322,3.322,0,0,1-.618,2.046A3.717,3.717,0,0,1,470.369,45a5.123,5.123,0,0,1-1.977.4,4.6,4.6,0,0,1-2.786-.906",
    transform: "translate(-269.855 -18.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3541",
    "data-name": "Tracciato 3541",
    d: "M492.181,45.158a4.221,4.221,0,0,1-1.654-1.776,5.8,5.8,0,0,1-.583-2.664V33.038h1.9v7.784a3.428,3.428,0,0,0,.731,2.281,2.922,2.922,0,0,0,4.162,0,3.426,3.426,0,0,0,.732-2.281V33.038h1.9v7.679a5.842,5.842,0,0,1-.575,2.647,4.243,4.243,0,0,1-1.637,1.785,5.209,5.209,0,0,1-4.971.009",
    transform: "translate(-285.015 -19.219)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google_play_badge.4e2342b80a7b20893538d60f3a0aef06.svg";
export { ForwardRef as ReactComponent };